import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MODULOS } from '../config/modulos';
import { useAdmin } from '../context/AdminContext';
import { useRRHH } from '../context/RRHHContext';

// Badge por card: define texto + colores segun estado/badge del modulo.
function datosBadge(modulo) {
  if (modulo.estado === 'desarrollo') {
    return { texto: 'En desarrollo', bg: '#f0f0f0', color: '#888', italic: false };
  }
  if (modulo.estado === 'admin') {
    return { texto: 'Solo admin', bg: '#f0f0f0', color: '#888', italic: false };
  }
  if (modulo.badge === 'Nuevo') {
    return { texto: 'Nuevo', bg: '#EAF3DE', color: '#3B6D11', italic: false };
  }
  // Activo operativo (CxC, CxP): placeholder de contador (v37.1+).
  return { texto: 'contador pendiente', bg: '#f0f0f0', color: '#888', italic: true };
}

function Hub() {
  const navigate = useNavigate();
  const isAdmin = useAdmin();
  const esRRHH = useRRHH();

  // Configuracion solo visible para admins; los modulos con rol propio (RRHH,
  // v49 D16) solo a quien pertenece a ese grupo, admin no lo hereda.
  const visibles = MODULOS.filter(m =>
    (m.estado !== 'admin' || isAdmin) &&
    (m.rol !== 'rrhh' || esRRHH)
  );

  return (
    <div style={{ fontFamily: 'Segoe UI, sans-serif', padding: '24px 28px', maxWidth: 1100, margin: '0 auto' }}>
      <style>{`
        .hub-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
        @media (max-width: 768px) { .hub-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 480px) { .hub-grid { grid-template-columns: 1fr; } }
      `}</style>

      <div style={{
        fontSize: 11, color: '#aaa', textTransform: 'uppercase',
        letterSpacing: '0.5px', marginBottom: 4
      }}>
        Inicio
      </div>
      <h1 style={{ fontSize: 18, color: '#012E40', fontWeight: 500, margin: '0 0 20px' }}>
        &iquest;Qu&eacute; quieres trabajar hoy?
      </h1>

      <div className="hub-grid">
        {visibles.map(modulo => {
          const esDesarrollo = modulo.estado === 'desarrollo';
          const badge = datosBadge(modulo);
          const colorIcono = esDesarrollo ? '#888' : '#012E40';
          const colorTitulo = esDesarrollo ? '#555' : '#012E40';

          return (
            <div
              key={modulo.id}
              onClick={esDesarrollo ? undefined : () => navigate(modulo.rutaPorDefecto)}
              style={{
                position: 'relative',
                background: '#fff',
                border: '0.5px solid #e0e0e0',
                borderLeft: `3px solid ${modulo.colorBorde}`,
                borderRadius: 8,
                padding: '12px 14px',
                cursor: esDesarrollo ? 'not-allowed' : 'pointer',
                opacity: esDesarrollo ? 0.55 : 1,
                transition: 'box-shadow 0.15s, transform 0.15s'
              }}
              onMouseEnter={e => { if (!esDesarrollo) { e.currentTarget.style.boxShadow = '0 2px 10px rgba(1,46,64,0.10)'; } }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; }}
            >
              <span style={{
                position: 'absolute', top: 10, right: 10,
                background: badge.bg, color: badge.color,
                fontSize: 10, padding: '2px 6px', borderRadius: 8,
                fontStyle: badge.italic ? 'italic' : 'normal'
              }}>
                {badge.texto}
              </span>

              <i className={`ti ${modulo.icono}`} style={{ fontSize: 20, color: colorIcono }} aria-hidden="true" />
              <div style={{ fontSize: 14, fontWeight: 500, color: colorTitulo, marginTop: 8 }}>
                {modulo.titulo}
              </div>
              <div style={{ fontSize: 11, color: '#777', lineHeight: 1.35, marginTop: 3 }}>
                {modulo.descripcion}
              </div>
            </div>
          );
        })}
      </div>

      {/* Acceso rapido - placeholder visual (D5) */}
      <div style={{
        marginTop: 20, background: '#fff', border: '0.5px solid #e0e0e0',
        borderRadius: 8, padding: '12px 14px', display: 'flex',
        alignItems: 'center', gap: 10
      }}>
        <i className="ti ti-bolt" style={{ fontSize: 18, color: '#87B749' }} aria-hidden="true" />
        <span style={{ fontSize: 12, color: '#999', fontStyle: 'italic' }}>
          Acceso r&aacute;pido &mdash; pendiente de desarrollo
        </span>
      </div>
    </div>
  );
}

export default Hub;
